import React from "react";
import {connect} from "react-redux";

import JobPaymentPopupInput from "./JobPaymentPopupInput";

export const billingInputs = ["firstName", "lastName", "address", "city", "state", "country", "postal", "email"];


const JobPaymentPopupBilling = (props) => {

  const {billingInfo} = props;

  return (
    <div className="job-payment__content relative job-payment__container job-payment__billing">
      {billingInputs.map(property => {
        return <JobPaymentPopupInput key={property}
                                     property={property}
                                     value={billingInfo[property]}
                                     className="flex-item flex-item--50"/>
      })}
    </div>
  )
};

const mapStateToProps = (store) => {
  const {billingInfo} = store.jobPaymentState;

  return {
    billingInfo,
  };
};

export default (
  connect(mapStateToProps)(JobPaymentPopupBilling)
)
